import React from 'react';
import './Product_ifile26.css';

const Product_ifile26 = () => {
  const steps = [
  { id: 1, title: "File Upload", icon: "bi-file-earmark-arrow-up" },
  { id: 2, title: "AI Data Processing", icon: "bi-cpu" },
  { id: 3, title: "User Assignment", icon: "bi-person-check" },
  { id: 4, title: "Workflow Approvals", icon: "bi-check2-square" },
  { id: 5, title: "Real Time Tracking", icon: "bi-geo-alt" },
  { id: 6, title: "Secure Data Storage", icon: "bi-database-lock" },
  { id: 7, title: "Instant Reports", icon: "bi-bar-chart-line" }
];

  return (
    <div className="container-fluid ifile-flow-bg-system">
      
      {/* Top Heading Area */}
      
        <div className="ifile-flow-header-section">
        <h1 className="ifile-flow-main-title">iFile Processing Management System</h1>
       
      </div>
<div className='row'>
<div className='col-12 col-sm-6 col-md-6 ifile-flow-left-content'>

  <div className="ifile-flow-content-item">
    <div className="ifile-flow-content-number">1</div>
    <div className="ifile-flow-content-text">
      <h4>File Upload</h4>
      <p>Files are uploaded into the system through a secure and centralized interface.</p>
    </div>
  </div>

  <div className="ifile-flow-content-item">
    <div className="ifile-flow-content-number">2</div>
    <div className="ifile-flow-content-text">
      <h4>AI Data Processing</h4>
      <p>Documents are processed using AI technologies like OCR and text recognition.</p>
    </div>
  </div>

  <div className="ifile-flow-content-item">
    <div className="ifile-flow-content-number">3</div>
    <div className="ifile-flow-content-text">
      <h4>User Assignment</h4>
      <p>Files are automatically assigned to relevant users based on roles and workflows.</p>
    </div>
  </div>

  <div className="ifile-flow-content-item">
    <div className="ifile-flow-content-number">4</div>
    <div className="ifile-flow-content-text">
      <h4>Workflow Approvals</h4>
      <p>Files move through defined workflows with step-by-step approvals.</p>
    </div>
  </div>

  <div className="ifile-flow-content-item">
    <div className="ifile-flow-content-number">5</div>
    <div className="ifile-flow-content-text">
      <h4>Real-Time Tracking</h4>
      <p>Track file status and progress in real-time with complete visibility.</p>
    </div>
  </div>

  <div className="ifile-flow-content-item">
    <div className="ifile-flow-content-number">6</div>
    <div className="ifile-flow-content-text">
      <h4>Secure Data Storage</h4>
      <p>All data is securely stored with encryption and compliance standards.</p>
    </div>
  </div>

  <div className="ifile-flow-content-item">
    <div className="ifile-flow-content-number">7</div>
    <div className="ifile-flow-content-text">
      <h4>Instant Reports</h4>
      <p>Generate reports instantly for better insights and decision-making.</p>
    </div>
  </div>

</div>
<div className='col-12 col-sm-6 col-md-6 ifile-flow-bg-dark1'>
<div className="ifile-flow-circle-container">
        
        {/* --- BACKGROUND SVG RING (The Blue Arrows) --- */}
        <svg className="ifile-flow-ring-svg" viewBox="0 0 100 100">
          <defs>
            <linearGradient id="techBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0056D2" /> {/* Dark Blue */}
              <stop offset="100%" stopColor="#00A0E3" /> {/* Light Blue */}
            </linearGradient>
          </defs>
          
          {/* We render segments based on the 7 steps */}
          {steps.map((_, i) => {
            const total = 7;
            // 360 degrees / 7 = 51.4 degrees per segment
            const anglePerSegment = 360 / total; 
            // We want the arc to be slightly smaller than the full segment to leave a gap
            const arcLength = anglePerSegment - 4; 
            
            const startAngle = (i * anglePerSegment) + 2; // +2 for centering the gap
            const endAngle = startAngle + arcLength;

            return (
              <g key={i}>
                {/* The Arc Path */}
                <path
                  d={describeArc(50, 50, 35, startAngle, endAngle)}
                  fill="none"
                  stroke="url(#techBlue)"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                />
                {/* The Arrowhead */}
                <polygon
                  points="0,0 -3,-4 3,-4" // Simple Arrow shape
                  fill="url(#techBlue)"
                  transform={`rotate(${endAngle}, 50, 50) translate(${50 + 35 * Math.cos(endAngle * Math.PI/180)}, ${50 + 35 * Math.sin(endAngle * Math.PI/180)}) rotate(${endAngle + 90})`}
                />
              </g>
            );
          })}
        </svg>

        {/* --- CENTER HUB --- */}
        <div className="ifile-flow-center-hub">
          <div className="ifile-flow-hub-inner">
            <div className="ifile-flow-hub-title">HOW OUR<br/>SYSTEM WORKS</div>
            <div className="ifile-flow-hub-number">07</div>
            <div className="ifile-flow-hub-sub">STEPS</div>
          </div>
        </div>

        {/* --- OUTER STEPS (7 Items) --- */}
        <div className="ifile-flow-steps-container">
          {steps.map((step, i) => {
            // Calculate position in a circle
            const angle = (i * (360 / 7)) - 90; // -90 to start at top
            const radius = 35; // Same radius as SVG ring
            
            // Trig to get X/Y %
            const x = 50 + radius * Math.cos(angle * Math.PI / 180);
            const y = 50 + radius * Math.sin(angle * Math.PI / 180);

            return (
              <div 
                key={step.id} 
                className="ifile-flow-step-bubble"
                style={{
                  left: `${x}%`,
                  top: `${y}%`
                }}
              >
                {/* Number Badge */}
                <div className="ifile-flow-step-num">{step.id}</div>
                
                {/* Icon Circle */}
                <div className="ifile-flow-step-icon-box">
                  <i className={`bi ${step.icon}`}></i>
                </div>
                
                {/* Title Text */}
                <div className="ifile-flow-step-text">{step.title}</div>
              </div>
            );
          })}
        </div>

      </div>
</div>
</div>

    </div>
  );
};

// Helper function to generate SVG Arc path
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
}

function describeArc(x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);
  var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  var d = [
    "M", start.x, start.y, 
    "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
  ].join(" ");
  return d;
}

export default Product_ifile26;